import React from 'react';
import numeral from 'numeral';
import DateHelper from '../../DateHelper/DateHelper';

export default class ReportPresenterTable extends React.Component {
  constructor(props) {
    super(props)
    this.exportCSV = this.exportCSV.bind(this);
  };

  render() {
    return (
      <div className="data-table report-table chart-wrapper" style={!this.props.viewOptionsSideBar ? { width: "95%" } : { width: "78%" }}>
        <div>
          <div className="flexed content-right">
            <button type="button" target='_blank' onClick={this.exportCSV} className="btn btn-primary btn-sm pull-right" style={{ marginTop: '5px' }} >{I18n.t('export_to_csv')}</button>
          </div>
          <table className="table" style={{margin: 'auto', border: '1px solid #dddddd'}}>
            {this.renderTableHead()}
            {this.renderTableRows()}
            {this.renderTableFooter()}
          </table>
        </div>
      </div>
    );
  };

  renderTableHead() {
    if (this.props.report_details.chart_type.name === 'horizontal_bar_chart') {
      var yDetail = this.props.report_details.data_details.find(detail => detail.chart_element === 'y-axis')
      var xDetails = this.props.report_details.data_details.filter(detail => detail.chart_element != 'y-axis')
      var columns = xDetails.map(detail => <th key={detail.id + detail.data_column_name} style={{ position: "sticky", top: '-17px', backgroundColor: 'white', borderBottom: '2px solid #dddddd', textAlign: 'right' }} >{detail.data_column_name.toLowerCase().replace(/_/g, " ").split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ')}</th>)
      columns.unshift(<th key={yDetail.id + yDetail.data_column_name} style={{ position: "sticky", top: '-17px', backgroundColor: 'white', borderBottom: '2px solid #dddddd' }} >{yDetail.data_column_name.toLowerCase().replace(/_/g, " ").split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ')}</th>)
    } else {
      var yDetails = this.props.report_details.data_details.filter(detail => detail.chart_element != 'x-axis')
      var xDetail = this.props.report_details.data_details.find(detail => detail.chart_element === 'x-axis')
      var columns = yDetails.map(detail => <th key={detail.id + detail.data_column_name} style={{ position: "sticky", top: '-17px', backgroundColor: 'white', borderBottom: '2px solid #dddddd', textAlign: 'right'}} >{detail.data_column_name.toLowerCase().replace(/_/g, " ").split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ')}</th>)
      columns.unshift(<th key={xDetail.id + xDetail.data_column_name} style={{ position: "sticky", top: '-17px', backgroundColor: 'white', borderBottom: '2px solid #dddddd'}} >{xDetail.data_column_name.toLowerCase().replace(/_/g, " ").split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ')}</th>)
    };
    return(
      <thead>
        <tr style={{backgroundColor:'white'}}>
          {columns}
        </tr>
      </thead>
    );
  };

  renderTableRows() {
    if(this.props.report_details.chart_type.name === 'horizontal_bar_chart'){
      var xDetails = this.props.report_details.data_details.filter(detail => detail.chart_element != 'y-axis')
      var yDetail = this.props.report_details.data_details.find(detail => detail.chart_element === 'y-axis')
      var rows = this.props.tableData.map((row, idx) => {
        var xAxisData = xDetails.map((detail) => {
          if (detail.data_type === 'currency') {
            return (
              <td key={detail.id + detail.data_column_name + idx} style={{ textAlign: 'right' }}>{this.formatCurrency(row[detail.data_column_name])}</td>
            );
          };
        });
        return (
          <tr style={idx % 2 === 1 ? { backgroundColor: 'white' } : null}>
            <td>
              {yDetail.data_type === 'date' ? DateHelper.printDateToScreen(row[yDetail.data_column_name], this.props.date_format) : row[yDetail.data_column_name]}
            </td>
            {xAxisData}
          </tr>
        )
      });
    } else {
      var yDetails = this.props.report_details.data_details.filter(detail => detail.chart_element != 'x-axis')
      var xDetail = this.props.report_details.data_details.find(detail => detail.chart_element === 'x-axis')
      var rows = this.props.tableData.map((row, idx) => {
      var yAxisData = yDetails.map((detail) => {
          if(detail.data_type === 'currency') {
            return(
              <td key={detail.id + detail.data_column_name + idx} style={{textAlign: 'right'}}>{this.formatCurrency(row[detail.data_column_name])}</td>
            )
          } else if(detail.data_type === 'percent') {
            return (
              <td key={detail.id + detail.data_column_name + idx} style={{ textAlign: 'right' }}>{Math.round(row[detail.data_column_name] * 100)}%</td>
            )
          };
        });
        return(
          <tr style={idx % 2 === 1 ? {backgroundColor:'white'} : null} key={idx}>
            <td>
              {xDetail.data_type === 'date' ? DateHelper.printDateToScreen(row[xDetail.data_column_name], this.props.date_format) : row[xDetail.data_column_name]}
            </td>
            {yAxisData}
          </tr>
        )
      });
    };

    return(
      <tbody>
        {rows}
      </tbody>
    );
  };

  renderTableFooter(){
    if (this.props.report_details.chart_type.name === 'horizontal_bar_chart') {
      var xDetails = this.props.report_details.data_details.filter(detail => detail.chart_element != 'y-axis')
      var yDetail = this.props.report_details.data_details.find(detail => detail.chart_element === 'y-axis')
      var totals = xDetails.map((detail) => {
        var total = this.calculateTotal(detail.data_column_name)
        return <th key={detail.data_column_name} style={{ position: "sticky", bottom: '-17px', backgroundColor: 'white', borderBottom: '2px solid #dddddd', textAlign: 'right' }}><strong>{this.formatCurrency(total)}</strong></th>
      });
      var totalRow = <tr style={this.props.tableData.length % 2 === 1 ? { backgroundColor: 'white' } : null}><th style={{ position: "sticky", bottom: '-17px', backgroundColor: 'white', borderBottom: '2px solid #dddddd' }}><strong>{I18n.t('total')}</strong></th>{totals}</tr>
    } else {
      var yDetails = this.props.report_details.data_details.filter(detail => detail.chart_element != 'x-axis')
      var xDetail = this.props.report_details.data_details.find(detail => detail.chart_element === 'x-axis')

      var totals = yDetails.map((detail) => {
        var total = this.calculateTotal(detail.data_column_name, detail.data_type)
        if (detail.data_type == "percent") {
          return <th key={detail.data_column_name} style={{ position: "sticky", bottom: '-17px', backgroundColor: 'white', borderBottom: '2px solid #dddddd', textAlign: 'right' }}><strong>{total}%</strong></th>
        } else {
          return <th key={detail.data_column_name} style={{ position: "sticky", bottom: '-17px', backgroundColor: 'white', borderBottom: '2px solid #dddddd', textAlign: 'right' }}><strong>{this.formatCurrency(total)} / {this.formatCurrency((total / this.props.tableData.length))}</strong></th>
        };
      }); 

      var totalRow = <tr style={this.props.tableData.length % 2 === 1 ? { backgroundColor: 'white' } : null}><th style={{ position: "sticky", bottom: '-17px', backgroundColor: 'white', borderBottom: '2px solid #dddddd' }}><strong>{yDetails[0].data_type == "percent" ? I18n.t('average') : I18n.t('total/average')}</strong></th>{totals}</tr>
    }
    return (
      <tfoot>
        {totalRow}
      </tfoot>
    );
  };

  formatCurrency(num) {
    return I18n.t('number.currency.format.unit') + numeral(num).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  }

  calculateTotal(columnName, dataType) {
    if (dataType == "percent"){
      var total = this.props.tableData.reduce((acc, data) => {
        return acc += parseFloat(data[columnName])
      }, 0);
      return Math.round((total / this.props.tableData.length) * 100);
    } else {
      return this.props.tableData.reduce((acc, data) => {
        return acc += parseInt(data[columnName])
      }, 0);
    };
  };

  exportCSV() {
    var tableData = JSON.stringify(this.props.tableData)

    $.ajax({
      type: 'POST',
      url: this.props.report_details.export_url,
      data: {
        table_data: tableData,
      },
    }).done((data) => {
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
        const blob = new Blob([data.csv], { type: "octet/stream" }),
          url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = data.file_name;
        a.click();
        window.URL.revokeObjectURL(url);
    });
  }
};